const $ = window.jQuery
import appUtils from './app_utils'

const setMetadataOffset = function() {
    const $metawrapper = $('.wp-block-cover.is-c24-featured-image + .is-c24-metadata-columns-wrapper').first();
    if ($metawrapper) {
      const hg = $('.wp-block-cover.is-c24-featured-image .wp-block-cover__inner-container').innerHeight() + 20
      const $metacolumn = $metawrapper.find('.c24-metadata-column-wrapper').first()
      if (appUtils.isMd()) {
        if ($metacolumn && hg) {
          $metacolumn.css('marginTop', -hg)
        }
      } else {
        $metacolumn.css('marginTop', 0)
      }
    }
  
}

export default {setMetadataOffset}